import React from "react";
import { useLang } from "../i18n";
import { LEGAL } from "../data/content";
import { LegalLayout } from "../components/LegalLayout";

export default function Terms() {
  const { lang } = useLang();
  return (
    <LegalLayout
      label={lang === "ro" ? "Legal" : "Legal"}
      title={lang === "ro" ? "Termeni și condiții" : "Terms & Conditions"}
      sections={LEGAL.terms}
    />
  );
}
